import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { FlexContainer } from './FlexContainer';
import { InputStyled } from './InputStyled';
import { RelativeInputDiv } from './RelativeInputDiv';

export const Nav = styled.nav`
  padding: 20px 10%;
  position: fixed;
  min-width: 100%;
  top: 0;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 3px solid #ededed;
  box-shadow: 5px 5px 10px 1px #ededed;
  height: 50px;
  z-index: 2;
`;

export const SearchDiv = styled(RelativeInputDiv)`
  padding: 0;
  margin: auto -70px;
  @media (max-width: 768px) {
    max-width: 271px;
  }
  @media (max-width: 1150px) {
    display: none;
  }
`;

export const NavList = styled.div`
   font-weight:bold;
   display:flex;
   justify-content:space-between;
   align-items:center;
   gap:2rem;
   }
   @media (max-width: 1150px) {
    display:none;
  }
`;

export const GotivaLogo = styled.img`
  width: 80px;
  height: auto;
  margin-right: 50px;
  cursor: pointer;
`;

export const NavIcon = styled.img`
  cursor: pointer;
  padding: 10px;
  width: 17px;
`;

export const ProfileImage = styled.img`
  width: 30px;
  height: 30px;
  margin-left: 5px;
  cursor: pointer;
`;

export interface NavLinkProps {
  activeClassName: string;
}

export const DashNavLink = styled(NavLink)`
  text-decoration: none;
  text-transform: uppercase;
  padding: 3px 0;
  color: #2a2a2a;
  &.${(props: NavLinkProps) => props.activeClassName} {
    &::after {
      background-color: #585cea;
      box-shadow: 0px 0px 5px 2px #585cea;
    }
  }
  cursor: pointer;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 30px;
    top: 15px;
    height: 80px;
    transition: 0.3s all;
    border-radius: 3px;
    width: 3px;
    transform: rotate(90deg);
    @media (max-width: 1150px) {
      top: 9px;
    }
  }
  &:nth-child(2)::after {
    left: 60px;
    height: 130px;
    top: -11px;
  }
  &:nth-child(5)::after {
    left: 50px;
    height: 100px;
    top: 5px;
  }
  &:nth-child(6)::after {
    left: 40px;
    height: 100px;
    top: 5px;
  }
  &:hover {
    &::after {
      background-color: #585cea;
      box-shadow: 0px 0px 5px 2px #585cea;
    }
  }
`;

export const DashNavLinkPopover = styled(NavLink)`
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
  width: 80%;
  text-align: start;
  padding: 10px;
  color: #2a2a2a;
  &.${(props: NavLinkProps) => props.activeClassName} {
    color: ${(props) => props.theme.colors.purple};
  }
  &:nth-child(2)::after {
    right: 80px;
    height: 200px;
  }
  cursor: pointer;
  position: relative;
  &:hover {
    color: ${(props) => props.theme.colors.purple};
  }
`;

export const NavIcons = styled(FlexContainer)`
  margin-right: 19%;
  @media (max-width: 1150px) {
    display: none;
  }
`;

export const NavSearchInput = styled(InputStyled)`
  height: 10x;
  box-shadow: 0px 0px 10px 0.5px ${(props) => props.theme.colors.lightGray};
  border: none;
`;

export const LogoutPopoverButton = styled.p`
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
  text-align: start;
  padding: 0px 10px;
  color: #2a2a2a;
`;
